// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uSR1","badges":"styles_badges__27T-h"};